import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  name: 'home',
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
